import { useThemedCollectionColors } from "@/mds/themes/use-themed-collection-colors";
import { CollectionChipProps } from "./collection-chip.types";
import { StyledChipWrapper, StyledContainer } from "./collection-chip.style";

export const MDSCollectionChip = ({
  collectionId,
  label,
  inline,
  onClick,
}: CollectionChipProps) => {
  const { bgColor, textColor } = useThemedCollectionColors(collectionId);
  return (
    <StyledContainer $inlineBlock={inline} onClick={onClick}>
      <StyledChipWrapper
        $inlineBlock={inline}
        style={{ backgroundColor: bgColor, color: textColor }}
      >
        {label}
      </StyledChipWrapper>
    </StyledContainer>
  );
};
